import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Modal, Button, Form, Table, Alert } from "react-bootstrap";
import axios from "axios";
import WeekSelector from "../weekSelector";
import DriverSelector from "../../components/driverSelector";
import { useTranslation } from 'react-i18next';
import { AiOutlineEye } from "react-icons/ai";
import { useLocation } from "react-router-dom";


const DriversDebts = () => {
    const { t } = useTranslation();
    const location = useLocation();
    const [selectedWeek, setSelectedWeek] = useState(null);

    const [users, setUsers] = useState([]);
    const [selectedUser, setSelectedUser] = useState(null);
    const [debts, setDebts] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [hideClosedDebts, setHideClosedDebts] = useState(false); // ✅ Додаємо стан чекбоксу
    const currentYear = new Date().getFullYear();
    const [validationError, setValidationError] = useState(null);

    const [newDebt, setNewDebt] = useState({
        driver_id: "",
        week_number: null,
        year: currentYear,
        debt_total: "",
        debt_name: "",
        debt_create_desc: "",
        debt_status: "open",
    });

    const navigate = useNavigate();

    useEffect(() => {
        axios.get("https://godrive.com.pl/api/users")
            .then((res) => setUsers(res.data))
            .catch((err) => console.error("Помилка завантаження списку водіїв:", err));
    }, []);

    useEffect(() => {
        let url = selectedUser
            ? `https://godrive.com.pl/api/drivers-debts?driver_id=${selectedUser.value}`
            : "https://godrive.com.pl/api/drivers-debts";

        console.log("Запит на борги водія:", { url, selectedUser });

        axios.get(url)
            .then((res) => {
                const updatedDebts = res.data.map(debt => {
                    const user = users.find(user => user.id === debt.driver_id);
                    return {
                        ...debt,
                        driver_firstName: user ? user.firstName : "Невідомий",
                        driver_lastName: user ? user.lastName : "Водій",
                    };
                });
                setDebts(updatedDebts);
            })
            .catch((err) => console.error("Помилка завантаження боргів:", err));
    }, [selectedUser, users]); // ✅ Додаємо залежність від `filterOpenDebts`

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const openModal = params.get("openModal");
        const driverId = params.get("driverId");
        const week = params.get("week");
        const sum = params.get("sum");
        const name = params.get("name");
        const desc = params.get("desc");

        if (openModal === "true") {
            setShowModal(true);
        }

        if (driverId) {
            const foundUser = users.find(user => user.id.toString() === driverId);
            if (foundUser) {
                setSelectedUser({ value: foundUser.id, label: `${foundUser.firstName} ${foundUser.lastName}` });
                setNewDebt(prev => ({
                    ...prev,
                    driver_id: foundUser.id,
                }));
            }
        }

        if (week) {
            setNewDebt(prev => ({
                ...prev,
                week_number: week,
            }));
        }

        if (sum || name || desc) {
            setNewDebt(prev => ({
                ...prev,
                debt_total: sum || prev.debt_total,
                debt_name: name || prev.debt_name,
                debt_create_desc: desc || prev.debt_create_desc,
            }));
        }
    }, [location.search, users]);



    const handleSelectDriver = (driver) => {
        if (driver && driver.value) {
            console.log("Обраний водій:", driver);
            setSelectedUser(driver);
        } else {
            console.warn("Помилка: некоректний водій", driver);
            setSelectedUser(null);
        }
    };

    const validateForm = () => {
        if (!newDebt.driver_id) {
            setValidationError(t("chooseDriverAlert"));
            return false;
        }
        if (!newDebt.week_number) {
            setValidationError(t("chooseWeekAlert"));
            return false;
        }
        if (!newDebt.year || newDebt.year < 2000 || newDebt.year > currentYear) {
            setValidationError(t("chooseYearAlert"));
            return false;
        }
        if (!newDebt.debt_total || parseFloat(newDebt.debt_total) <= 0) {
            setValidationError(t("debtSumAlert"));
            return false;
        }
        if (!newDebt.debt_name.trim()) {
            setValidationError(`${t("emptyAlert")} - ${t("name")}`);
            return false;
        }
        if (!newDebt.debt_create_desc.trim()) {
            setValidationError(`${t("emptyAlert")} - ${t("description")}`);
            return false;
        }

        setValidationError(null);
        return true;
    };

    const handleCreateDebt = () => {

        if (!validateForm()) return;

        axios.post("https://godrive.com.pl/api/drivers-debts", newDebt)
            .then(() => {
                setShowModal(false);
                setNewDebt({
                    driver_id: "",
                    week_number: null,
                    year: currentYear,
                    debt_total: "",
                    debt_name: "",
                    debt_create_desc: "",
                    debt_status: "open",
                });
                setSelectedUser(null);


                if (selectedUser) {
                    axios.get(`https://godrive.com.pl/api/drivers-debts?driver_id=${selectedUser.value}`)
                        .then((res) => setDebts(res.data));
                }
                navigate("/admin/driver-debts");

            })
            .catch((err) => console.error("Помилка створення боргу:", err));
    };

    const handleDeleteDebt = async (debtId) => {
        const confirm = window.confirm("Ви дійсно хочете видалити цей борг?");
        if (!confirm) return;
    
        try {
            await axios.delete(`https://godrive.com.pl/api/drivers-debts/${debtId}`, {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
              });
            setDebts(prev => prev.filter(debt => debt.id !== debtId));
        } catch (error) {
            console.error("❌ Помилка при видаленні боргу:", error);
            alert("Не вдалося видалити борг");
        }
    };
    

    return (
        <div className="container mt-4">
            <h2>{t("debts")}</h2>

            <Form.Group className="mb-3">
                <DriverSelector selectedDriver={selectedUser} setSelectedDriver={handleSelectDriver} />
            </Form.Group>

            {/* ✅ Додаємо чекбокс для приховування закритих боргів */}
            <Form.Group className="mb-3">
                <Form.Check
                    type="checkbox"
                    label={t("hideCloseDebts")}
                    checked={hideClosedDebts}
                    onChange={(e) => setHideClosedDebts(e.target.checked)}
                />
            </Form.Group>

            <Button variant="primary" onClick={() => setShowModal(true)}>{t("create")}</Button>

            <Table striped bordered hover className="mt-3">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>{t("driver")}</th>
                        <th>{t("debt")}</th>
                        <th>{t("debt")} {t("name").toLowerCase()}</th>
                        <th>{t("status")}</th>
                        <th>{t("actions")}</th>
                    </tr>
                </thead>
                <tbody>
                    {debts
                        .filter(debt => !hideClosedDebts || debt.debt_status !== "closed")
                        .map(debt => (
                            <tr key={debt.id}>
                                <td>{debt.id}</td>
                                <td>{`${debt.driver_firstName} ${debt.driver_lastName}`}</td>
                                <td>{debt.debt_total}</td>
                                <td>{debt.debt_name}</td>
                                <td>{debt.debt_status}</td>
                                <td>

                                    <AiOutlineEye
                                        style={{ cursor: "pointer", marginRight: "10px", color: "orange" }}
                                        size={20}
                                        onClick={() => navigate(`/admin/driver-debts/${debt.id}`)}
                                    />
                                    {debt.debt_status === "closed" && (
                                        <span
                                            style={{ cursor: "pointer", color: "red", marginLeft: "10px" }}
                                            onClick={() => handleDeleteDebt(debt.id)}
                                            title="Видалити борг"
                                        >
                                            🗑️
                                        </span>
                                    )}
                                </td>
                            </tr>
                        ))}
                </tbody>
            </Table>



            {/* Модальне вікно для додавання боргу */}
            <Modal show={showModal} onHide={() => setShowModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>{t("add")} {t("debt").toLocaleLowerCase()}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {validationError && <Alert variant="danger">{validationError}</Alert>}
                    <Form>
                        <Form.Group>
                            <Form.Label>{t("driver")}</Form.Label>
                            <DriverSelector
                                selectedDriver={newDebt.driver_id ?
                                    {
                                        value: newDebt.driver_id,
                                        label: users.find(user => user.id === newDebt.driver_id)?.firstName + " " + users.find(user => user.id === newDebt.driver_id)?.lastName
                                    }
                                    : null
                                }
                                setSelectedDriver={(driver) => {
                                    setNewDebt(prevDebt => ({
                                        ...prevDebt,
                                        driver_id: driver ? driver.value : ""
                                    }));
                                }}
                            />
                        </Form.Group>

                        <Form.Group>

                            <WeekSelector
                                selectedWeek={newDebt.week_number}
                                setSelectedWeek={(week) => setNewDebt({ ...newDebt, week_number: week })}
                            />
                        </Form.Group>

                        <Form.Group>
                            <Form.Label>{t("year")}</Form.Label>
                            <Form.Control
                                type="number"
                                value={newDebt.year}
                                onChange={(e) => setNewDebt({ ...newDebt, year: e.target.value })}
                            />
                        </Form.Group>

                        <Form.Group>
                            <Form.Label>{t("value")}</Form.Label>
                            <Form.Control
                                type="number"
                                value={newDebt.debt_total}
                                onChange={(e) => setNewDebt({ ...newDebt, debt_total: e.target.value })}
                            />
                        </Form.Group>

                        <Form.Group>
                            <Form.Label>{t("name")}</Form.Label>
                            <Form.Control
                                type="text"
                                value={newDebt.debt_name}
                                onChange={(e) => setNewDebt({ ...newDebt, debt_name: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{t("description")}</Form.Label>
                            <Form.Control
                                type="text"
                                value={newDebt.debt_create_desc}
                                onChange={(e) => setNewDebt({ ...newDebt, debt_create_desc: e.target.value })}
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>{t("close")}</Button>
                    <Button variant="primary" onClick={handleCreateDebt}>{t("add")}</Button>
                </Modal.Footer>
            </Modal>



        </div>
    );
};

export default DriversDebts;
